module.exports = __webpack_public_path__ + "img/keys.600a24eb.png";